import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import { AnalyticsServiceImpl } from 'src/services/AnalyticsService/impl';
import { AmplitudeWebTransport } from 'src/services/AnalyticsService/transports/AmplitudeWebTransport';
import { ConsoleTransport } from 'src/services/AnalyticsService/transports/ConsoleTransport';
import { DatadogWebTransport } from 'src/services/AnalyticsService/transports/DatadogWebTransport';
import type { IsomorphicBindings } from 'src/types/bindings';

export const webAnalyticsModule = new TypedContainerModule<IsomorphicBindings>((bind) => {
    if (TRACE) {
        bind('AnalyticsTransport').to(ConsoleTransport).inSingletonScope();
    }

    bind('AnalyticsTransport').to(DatadogWebTransport).inSingletonScope();
    bind('AnalyticsTransport').to(AmplitudeWebTransport).inSingletonScope();

    bind('AnalyticsService').to(AnalyticsServiceImpl).inSingletonScope();
});
